"use client";

import React from "react";
import "./FAQ.css";
import Accordion from "react-bootstrap/Accordion";

const FAQ = () => {
  const faqs = [
    {
      id: "faq1",
      question: " 1.	Can I get a BCA degree online?",
      answer:
        "Yes, you can pursue online BCA in India from a UGC-entitled and AICTE-recognised university such as DPU COL. The university ranked among the top 50 universities by the NIRF ranking framework 2024.",
    },
    {
      id: "faq2",
      question: " 2.	Is online BCA valid?",
      answer:
        "Online BCA degree earned from a UGC and NAAC accredited university is valid for all jobs across the country and globally.",
    },
    {
      id: "faq3",
      question: "3. Is Online BCA from DPU-COL valid?",
      answer:
        "Online BCA degree is recognised by UGC and AICTE. It is also accredited with NAAC grade “A++” and is ranked among the top 50 universities in the nation by NIRF ranking.",
    },
    {
      id: "faq4",
      question:
        "4. What practical skills will I gain from the online BCA degree?",
      answer:
        "Online learners get exposed to several skills while gaining their online BCA degree. They will learn new programming languages such as C, C++, Java, web technologies, database management, statistics, etc.",
    },
  ];

  return (
    <section className="FAQ_Section">
      <div className="container">
        {/* Section Heading */}
        <div className="FAQ_Section_Heading">
          <span className="FAQ_eyebrow">Frequently Asked Questions</span>

          <h2>
            FAQs About <span>Online BCA</span>
          </h2>

          <p>
            Find answers to some of the most common questions about our Online
            BCA program.
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="FAQ_Accordion_Wrapper">
          <Accordion>
            {faqs.map((item, index) => (
              <Accordion.Item
                eventKey={item.id}
                key={item.id}
                className="FAQ_Accordion_Item"
              >
                <Accordion.Header>
                  <div className="FAQ_Question">
                    <span className="FAQ_Number">
                      {String(index + 1).padStart(2, "0")}
                    </span>

                    <span>{item.question}</span>
                  </div>
                </Accordion.Header>

                <Accordion.Body>
                  <div className="FAQ_Answer">{item.answer}</div>
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
